import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'roundNumber'
})
export class RoundNumberPipe implements PipeTransform {

    transform(value: number, decimals: number = 1): string {
        if (!value) return '0';
        return value.toFixed(decimals);
    }

}
